/* Other */
import { makeFetchActionTypes, makeFetchActionCreators } from "../../utils";

export const baseActionName = "search";
export const actionTypes = makeFetchActionTypes(baseActionName);
export const searchResultsActionCreators = makeFetchActionCreators(baseActionName);
export const { fetch: fetchSearchResults, reset: resetSearchResults } = searchResultsActionCreators;
